// extracted by css-extract-rspack-plugin
export default {"cls1":"PostEngagementFollowPrompt-cls1_CWA","cls2":"PostEngagementFollowPrompt-cls2_yBM PostEngagementFollowPrompt-cls1_CWA"};